import WealthyConstants from 'constants/wealthyConstants';
import {getMinDateOfBirthForMinor} from 'utils/dateUtils';

export const getMinorDetailsFormSchema = (allowedGenders) => {
  const minMinorDobIso = getMinDateOfBirthForMinor();
  const todayIso = new Date().toISOString().split('T')[0];
  const genderOptions =
    Array.isArray(allowedGenders) && allowedGenders.length > 0
      ? allowedGenders.map((g) => {
          return {value: g.key, label: g.render};
        })
      : WealthyConstants.DEFAULT_GENDER_OPTIONS;

  return {
    theme: {
      type: 'mui',
      mui: {
        size: 'small',
        variant: 'outlined',
        gapX: 0,
        gapY: 0,
      },
      className: 'basic-form',
    },
    fields: [
      {
        name: 'name',
        meta: {
          displayName: 'Name of the Minor',
          displayType: 'text',
          className: 'input-container',
          value: '',
          displayProps: {
            sm: 12,
            md: 12,
          },
          validation: {
            max: {
              value: 35,
              errorMsg: 'Maximum 35 characters allowed',
            },
            required: true,
            pattern: {
              value: '^[A-Za-z]+(?:\\s?[A-Za-z]+)*$',
              errorMsg: 'Special characters, numbers or multiple spaces are not allowed',
            },
          },
        },
      },
      {
        name: 'dob',
        meta: {
          displayName: 'DOB of the Minor as per the official document',
          displayType: 'date',
          className: 'input-container',
          placeholder: 'DD/MM/YYYY',
          value: '',
          displayProps: {
            sm: 12,
            md: 12,
          },
          validation: {
            required: true,
            min: {
              value: minMinorDobIso,
              errorMsg: 'Minor must be under 18 years of age',
            },
            max: {
              value: todayIso,
              errorMsg: 'Minor must be under 18 years of age',
            },
          },
        },
      },
      {
        name: 'gender',
        meta: {
          displayName: 'Gender of the Minor',
          displayType: 'select',
          className: 'input-container',
          value: '',
          displayProps: {
            sm: 12,
            md: 12,
          },
          options: genderOptions,
          validation: {
            required: true,
          },
        },
      },
    ],
    buttons: [],
  };
};
